import { render, staticRenderFns } from "./StatisticsTableHeader.vue?vue&type=template&id=06145892&"
import script from "./StatisticsTableHeader.vue?vue&type=script&lang=js&"
export * from "./StatisticsTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports